import React, { useState } from 'react';
import styles from '../adminPageMatch/adminPageMatch.module.css';

interface SubstituteFormProps {
    periods: { id: number; name: string }[];
    teams: { id: number; name: string }[];
    players: { id: number; number: number; last_name: string; team_id: number; }[];
    onAddSubstitute: (substituteData: SubstituteData) => void;
}

export interface SubstituteData {
    periodId: number;
    time: number;
    additionalTime: number | null;
    teamId: number;
    playerOutId: number;
    playerInId: number;
}

const SubstituteForm: React.FC<SubstituteFormProps> = ({ periods, teams, players, onAddSubstitute }) => {
    const [periodId, setPeriodId] = useState<number>(0);
    const [time, setTime] = useState<string>('');
    const [additionalTime, setAdditionalTime] = useState<string>('');
    const [teamId, setTeamId] = useState<number>(0);
    const [playerNumbers, setPlayerNumbers] = useState<string>('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        console.log(teamId)
        console.log(teamId)
        const [playerOutNumber, playerInNumber] = playerNumbers.split(',').map(num => parseInt(num.trim()));
        const playerOut = players.find(p => p.number === playerOutNumber && p.team_id === teamId);
        const playerIn = players.find(p => p.number === playerInNumber && p.team_id  === teamId);
        console.log(players)

        console.log(playerOut, playerIn)

        if (!playerOut || !playerIn) {
            alert('Invalid player numbers');
            return;
        }

        const substituteData: SubstituteData = {
            periodId: periodId,
            time: parseInt(time),
            additionalTime: additionalTime ? parseInt(additionalTime) : null,
            teamId: teamId,
            playerOutId: playerOut.id,
            playerInId: playerIn.id,
        };



        onAddSubstitute(substituteData);

        // Reset form
        setPeriodId(0);
        setTime('');
        setAdditionalTime('');
        setTeamId(0);
        setPlayerNumbers('');
    };

    return (
        <form onSubmit={handleSubmit} className={styles.substituteForm}>
            <h3>Add Substitution</h3>
            <div className={styles.addEvent}>
            <select
                value={periodId}
                onChange={(e) => setPeriodId(parseInt(e.target.value))}
                required
            >
                <option value="">Select Period</option>
                {periods.map((period) => (
                    <option key={period.id} value={period.id}>
                        {period.name}
                    </option>
                ))}
            </select>
            <input
                type="number"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                placeholder="Time"
                required
            />
            <input
                type="number"
                value={additionalTime}
                onChange={(e) => setAdditionalTime(e.target.value)}
                placeholder="Additional Time (optional)"
            />
            <select
                value={teamId}
                onChange={(e) => setTeamId(parseInt(e.target.value))}
                required
            >
                <option value="">Select Team</option>
                {teams.map((team) => (
                    <option key={team.id} value={team.id}>
                        {team.name}
                    </option>
                ))}
            </select>
            <input
                type="text"
                value={playerNumbers}
                onChange={(e) => setPlayerNumbers(e.target.value)}
                placeholder="Player Numbers (out, in)"
                required
            />
            <button type="submit">Add Substitution</button>
            </div>
        </form>
    );
};

export default SubstituteForm;